import React from 'react';
import {HTMLContent, contentUtils} from "mindsets-js-sdk";

import BaseAnswer from '../BaseAnswer';
import FractionPart from './FractionPart';
import IntegerPart from './IntegerPart';


export default class Fraction extends BaseAnswer {
    isValid() {
        return true;
    }

    onChange() {
        return () => e => {
            e.preventDefault();
        }
    }

    renderItem(itemData, fractionKey) {
        switch (itemData.type) {
            case 'hidden':
                return null;
            case 'static':
                const content = _.get(itemData, 'content.html');
                return (
                    <div className="cc-numberonly-item-static" style={itemData.style}>
                        <HTMLContent html_str={contentUtils.processStringContent(content)}/>
                    </div>
                );
            case 'fraction':
                return (
                    <FractionPart
                        component_data={this.props.component_data}
                        is_preview={this.props.is_preview}
                        answer={{}}
                        existing_answer={this.props.existing_answer}
                        onChange={this.onChange(fractionKey)}
                        itemData={itemData}
                        fractionKey={fractionKey}
                    />
                );
            case 'integer':
                return (
                    <IntegerPart
                        component_data={this.props.component_data}
                        is_preview={this.props.is_preview}
                        answer={{}}
                        existing_answer={this.props.existing_answer}
                        onChange={this.onChange(fractionKey)}
                        itemData={itemData}
                        fractionKey={fractionKey}
                    />
                );
            default:
                return null;
        }
    }

    renderAllItems() {
        const items = _.get(this.props.component_data, 'data.items', []);
        let fractionKey = -1;
        return items.map((itemData, itemKey) => {
            if (itemData.type === 'fraction' || itemData.type === 'integer') {
                fractionKey++;
            }
            return (
                <div key={itemKey}>
                    {this.renderItem(itemData, fractionKey)}
                </div>
            );
        });
    }

    render() {
        return (
            <div className="challenge-component-fraction">
                <div className="cc-fraction-description">
                    {`Enter a number in each box below.`}
                </div>

                <div className="d-flex flex-wrap align-items-center">
                    {this.renderAllItems()}
                </div>
            </div>
        )
    }
}
